export default __webpack_public_path__ + "static/media/city.acc93d94.png";